<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <i
          class="bi bi-x-lg float-start text-danger fw-bold"
          @click="clearAuction()"
        ></i>
      </div>
      <div class="col">
        <i
          class="bi bi-arrow-clockwise text-primary float-end"
          @click="refreshView()"
        ></i>
      </div>
    </div>
  </div>
  <div v-if="refresh">
    <div class="row border rounded p-1 bg-grad-yellow">
      <div class="col">
        <BiddingTeam></BiddingTeam>
      </div>
    </div>
    <div class="row p-1 border rounded bg-grad-blue" style="height: 50vh">
      <div class="col">
        <div v-if="live_auction.bidding_open">
          <LivePlayer
            :player_id="live_auction.live_player_id"
            :halt_bidding="live_auction.halt_bidding"
          ></LivePlayer>
        </div>
        <div v-else>
          <div class="row">
            <div class="col border rounded fw-bold">
              Player Auction
              <AuctionIcon></AuctionIcon>
            </div>
          </div>
        </div>
      </div>
      <div class="col overflow-hidden position-relative">
        <SoldPlayers></SoldPlayers>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <TeamsStatus></TeamsStatus>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col border rounded bg-info">Refreshing...</div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import { onMounted, ref } from "vue";
import supabase from "@/supabase/config";
import LivePlayer from "../liveplayer/LivePlayer.vue";
import SoldPlayers from "../soldplayers/SoldPlayers.vue";
import TeamsStatus from "../teamsstatus/TeamsStatus.vue";
import BiddingTeam from "../biddingteam/BiddingTeam.vue";
import AuctionIcon from "./AuctionIcon.vue";
const store = useStore();
const live_auction = ref({});
const refresh = ref(true);
onMounted(() => {
  setTimeout(() => {
    fetchAuction(); //1 sec delay to wait for things to stabalize
  }, 1000);
});
const fetchAuction = async () => {
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  live_auction.value = auctions[0];
  setupListner();
};
const setupListner = async () => {
  const channels = supabase
    .channel("bidder-liveauction-update-channel")
    .on(
      "postgres_changes",
      {
        event: "UPDATE",
        schema: "public",
        table: "auctions",
        filter: `id=eq.${store.live_auction}`,
      },
      (payload) => {
        live_auction.value = payload.new;
        if (!payload.new.active) {
          store.setAuction(""); //close LiveAuction as soon as auctioneer makes auction inactive
        }
      }
    )
    .subscribe();
};
const clearAuction = () => {
  store.setAuction("");
  store.setUserType("");
};

const refreshView = () => {
  refresh.value = false;
  setTimeout(() => {
    refresh.value = true;
  }, 1500);
};
</script>
